import { atom, useAtom } from 'jotai';

const turnaroundOriginDeliveryId = atom<number | null>(null);

export const useTurnaroundOriginDeliveryId = () => useAtom(turnaroundOriginDeliveryId);
